module.exports = __webpack_public_path__ + "media/images/phone-e60d635ea579b159bf93e21eabfe9237.png";